import {
  useAuthoredRows,
  useCreateAuthoredRow,
  useDeleteAuthoredRow,
  useUpdateAuthoredRow,
} from 'components/IAP/hooks/icsAuthoredFormHooks';
import { useRecordFormVersionSave } from 'components/IAP/hooks/icsFormVersionHooks';
import { useICSContext } from 'components/IAP/planningView/ICSContext';

import { Ics204CardSection } from '../AssignmentList/ics204BoxLabels';
import {
  ICS232A_BOX_LABELS,
  ICS232A_SITE_COLUMNS,
  ICS232A_SITE_INDEX_NOTE,
} from '../ics232aBoxLabels';
import {
  BoxRowTable,
  NewCgFormCard,
  NewCgHeaderBoxes,
  NewCgPreparedByBox,
} from './newCgFormBoxes';

/** ICS 232A-CG, boxed as the sheet prints it. */
const Ics232ACard = () => {
  const { effectivePeriodNumber } = useICSContext();
  const { data: sites = [] } = useAuthoredRows('acpSites');
  const createRow = useCreateAuthoredRow('acpSites');
  const updateRow = useUpdateAuthoredRow('acpSites');
  const deleteRow = useDeleteAuthoredRow('acpSites');
  const recordVersionSave = useRecordFormVersionSave(
    'ICS_232A',
    effectivePeriodNumber
  );
  const onSuccess = () => recordVersionSave.mutate();

  return (
    <NewCgFormCard
      title="ACP Site Index ICS-232A"
      formname="ICS_232A_CG"
      baseId="ICS_232A"
      exportLabel="Preview ICS-232A"
    >
      <NewCgHeaderBoxes labels={ICS232A_BOX_LABELS} testIdPrefix="ics232a" />

      <Ics204CardSection
        boxLabel={ICS232A_BOX_LABELS.siteIndex}
        testId="ics232a-section-site-index"
        className="tw:mt-0"
      >
        <p className="tw:mb-2 tw:text-xs tw:text-muted-foreground">
          {ICS232A_SITE_INDEX_NOTE}
        </p>
        <BoxRowTable
          columns={ICS232A_SITE_COLUMNS}
          rows={sites}
          identityColumn="site_id"
          testId="ics232a-sites-table"
          addLabel="Add Site"
          onSave={(entityId, patch) =>
            updateRow.mutate({ entityId, ...patch }, { onSuccess })
          }
          onDelete={(entityId) => deleteRow.mutate(entityId, { onSuccess })}
          onAdd={async () => {
            const created = await createRow.mutateAsync({});
            onSuccess();
            return String(created?.site_id ?? '');
          }}
        />
      </Ics204CardSection>

      <NewCgPreparedByBox
        baseId="ICS_232A"
        boxLabel={ICS232A_BOX_LABELS.preparedBy}
        testIdPrefix="ics232a"
      />
    </NewCgFormCard>
  );
};

export default Ics232ACard;
